import ActivityDetails from './activityDetails.js';
export default ActivityDetails;
